import { RoutePath } from 'enums/routePath';

const ROOT = `/customer-engagement`;

const SEGMENTS = `${ROOT}/segments-overview`;

export const coveragePaths = {
  [RoutePath.COVERAGE]: ROOT,
  [RoutePath.SEGMENTS]: SEGMENTS,
};

export const pathArray = Object.values(coveragePaths);

export default coveragePaths;
